var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronRightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_890_1932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 32.5187C37 31.5832 36.6632 30.7599 35.9522 30.049L6.27748 1.04763C5.64135 0.374374 4.81806 0.0375519 3.84515 0.0375519C1.89923 0.0375519 0.402416 1.49673 0.402416 3.44257C0.402416 4.41587 0.814037 5.23896 1.41277 5.87506L28.6552 32.5187L1.41277 59.1623C0.814037 59.7985 0.402416 60.6592 0.402416 61.5947C0.402416 63.5406 1.89923 65 3.84515 65C4.81806 65 5.64135 64.6632 6.27748 64.0271L35.9522 34.9885C36.6632 34.3149 37 33.4543 37 32.5187Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_890_1932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.5976,
    height: 65,
    fill: "white",
    transform: "matrix(-1 0 0 -1 37 65)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightIcon);
export default __webpack_public_path__ + "static/media/ChevronRightIcon.e32dda06182021c0206a11077c958a44.svg";
export { ForwardRef as ReactComponent };